export enum TipoTransaccion{
    Despacho = 0,
    DespachoInterno = 1,
    AjusteManual = 2,
    Transferencia = 3,
    Rebombeo = 4,
    Alije = 5,
    Recepcion = 6,
    RecepcionDucto = 7,
    Salida = 8,
    AjusteAutomatico = 9,
    Recarga =10
}
